import {useEffect} from 'react';

const useScrollToTop = () => {
  useEffect(() => {
    if (window && window.scrollTo) window.scrollTo(0, 0);
  }, []);
};

export default useScrollToTop;
